import { useQuery } from "react-query";
import {
  PortfolioReportsApi,
  ReportingControllerApi,
} from "@iliotech/generated-api-v3";
import { API_BASE } from "../../constants/constants";

export const useExecutiveReport = (
  portfolioId: string,
  fromDate: string,
  toDate: string
) => {
  const api = new ReportingControllerApi(undefined, `${API_BASE}/api`);
  return useQuery([`executive-report`, { portfolioId, fromDate, toDate }], () =>
    api.getPortfolioPnlPerCustodian1({
      portfolioId,
      fromDate,
      toDate,
    })
  );
};
